import { observer } from 'mobx-react';
import * as React from 'react';
import Main from '../../BrowserSupport/Main';
import Notifications from '../../Notifications';
import I18nTitle from '../../Title/I18nTitle';
import MainNav from '../Platform/MainNav';

interface Props {
  children: React.ReactNode;
}

const PageLayout: React.FC<Props> = ({ children }) => (
  <>
    <I18nTitle title="Single Sign-On" />
    <div className="min-h-screen">
      <MainNav />
      <Notifications />
      <div className="mx-auto w-full max-w-clientPortalMaxWidth">
        <Main id="main" className="min-h-[calc(100vh-150px)] px-2.5 py-8 lg:px-12">
          {children}
        </Main>
      </div>
    </div>
  </>
);

export default observer(PageLayout);
